import { useEffect, useRef } from "react";
import { Mesh } from "three";
import type { Group, Object3D } from "three";

import { useCenteredGltf } from "../../hooks/use-centered-gltf.js";
import { buildModelUrl } from "../office/office.service.js";
import { useOffice } from "../office/use-office.js";

export const DynamicOfficeRoom = () => {
  const { preset } = useOffice();
  const modelPath = buildModelUrl(
    preset.modelsDirectory,
    preset.manifest.model
  );

  const groupRef = useRef<Group>(null);
  const { center, clonedGltf } = useCenteredGltf(modelPath);

  useEffect(() => {
    const clonedModel = clonedGltf();
    clonedModel.traverse((child: Object3D) => {
      if (child instanceof Mesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
    // Apply centering offset to align model center with position
    clonedModel.position.set(-center.x, 0, -center.z);

    groupRef.current?.add(clonedModel);

    return () => {
      groupRef.current?.remove(clonedModel);
    };
  }, [clonedGltf, center.x, center.z]);

  return <group position={[0, 0, 0]} ref={groupRef} rotation={[0, 0, 0]} />;
};
